import actionTypes from '../../actions/Mode/types';

export const setMode = (mode) => async (dispatch) => {
  dispatch({
    type: actionTypes.HANDLE_MODE,
    payload: mode,
  });
};
